/**
 * External dependencies
 */
import { useEffect, useState } from 'react';
import { Head, router, usePage, useForm } from '@inertiajs/react';
import axios from 'axios';

/**
 * Internal dependencies
 */
import Guest from '@/hosts-marketplace/layouts/guest/guest';
import VerifyingContent from '@/hosts-marketplace/components/verifying-content/verifying-content';
import FormLogin from '@/hosts-marketplace/blocks/forms/form-login/form-login';

export default function Login({ status, googleLoginErrors = '', canResetPassword, recaptchaKey = null }) {
    const [isLoading, setIsLoading] = useState(false);
    const { data, setError, setData, processing, errors, reset } = useForm({
        email: '',
        password: '',
    });

    useEffect(() => {
        if (googleLoginErrors) {
            setError(googleLoginErrors);
        }

        return () => {
            reset('password');
        };
    }, []);

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.value);
    };

    const executeCaptchaAndLogin = () => {
        grecaptcha.execute(recaptchaKey, { action: 'login' }).then(function (token) {
            loginRequest(token);
        });
    };

    const loginRequest = (recaptchaToken = null) => {
        const dataToSend = recaptchaToken
            ? {
                  ...data,
                  recaptcha: recaptchaToken,
              }
            : data;

        axios
            .post('/login', dataToSend)
            .then((response) => {
                window.FS?.identify(response.data['user_id']);

                window.location.href = response.data.referrer || '/';

                return response;
            })
            .catch((error) => {
                if (error.response) {
                    const redirectToOnboarding = error.response?.data?.errors?.redirectTo;

                    if (redirectToOnboarding) {
                        router.visit(redirectToOnboarding[0]);
                    } else {
                        setError(error.response.data.errors);
                    }

                    return;
                }

                if (error.request) {
                    console.error(error.request);

                    return;
                }

                console.error('Login Error:', error.message);
            })
            .finally(() => setIsLoading(false));
    };

    const submit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (recaptchaKey && typeof grecaptcha !== 'undefined') {
            executeCaptchaAndLogin();
        } else {
            loginRequest();
        }
    };

    return (
        <Guest>
            <Head title="Sign In" />

            {errors.verifying ? (
                <VerifyingContent error={errors.verifying} />
            ) : (
                <FormLogin
                    data={data}
                    submit={submit}
                    processing={processing}
                    isLoading={isLoading}
                    onHandleChange={onHandleChange}
                    status={status}
                    canResetPassword={canResetPassword}
                    errors={errors}
                />
            )}
        </Guest>
    );
}
